import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import Header from '@components/layout/Header'
import CurrencyConverter from '@components/converter/CurrencyConverter'
import ErrorFallback from '@components/common/ErrorFallback'
import { useCurrencyStore } from '@stores/currencyStore'
import { useTheme } from '@/hooks/useTheme'
import { useEffect } from 'react'

const App: React.FC = () => {
  const { initializeApp, isLoading } = useCurrencyStore()
  useTheme() // Initialize theme management

  useEffect(() => {
    initializeApp()
  }, [initializeApp])

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
        <Header />
        <main className="p-6">
          {isLoading ? (
            <div className="flex items-center justify-center min-h-96">
              <div className="flex flex-col items-center space-y-4">
                <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 dark:text-gray-400">Loading exchange rates...</p>
              </div>
            </div>
          ) : (
            <CurrencyConverter />
          )}
        </main>
      </div>
    </ErrorBoundary>
  )
}

export default App